import { httpClient } from "@/services";
import { clientsListHeader } from "@/pages/Maintenance/Clients/constants";
import requestKeys from "@/constants/requestKeys";

export default {
	state: {
		clientsList: [],
		clientsFilter: {},
		clientsFilterDefault: null,
		clients: null,
		deleteClientsList: [],
		deleteInvoiceList: [],
		clientsPreloader: true
	},
	mutations: {
		updateClientsList(state, { filter, list, isDelete }) {
			if (!isDelete) state.clientsList = list;
			if (filter) state.clientsFilter = filter;
		},
		updateClientsPreloader(state, payload) {
			state.clientsPreloader = payload;
		},
		updateClients(state, payload) {
			state.clients = payload;
		},
		updateClientsDelete(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteClientsList = [];
			} else {
				state.deleteClientsList.push(id);
			}
		},
		updateAddClientsList(state, { list, id }) {
			const idx = state.clientsList.findIndex(item => item.id === id);

			if (list.status === "Canceled") {
				state.clientsList.splice(idx, 1);
			} else if (idx === -1) {
				state.clientsList.unshift(list);
			} else {
				state.clientsList.splice(idx, 1, list);
			}
		},
		updateClearClientsFilter(state) {
			state.clientsFilter = null;
			state.clientsFilterDefault = null;
		}
	},
	actions: {
		onClearClientsFilter({ commit }) {
			commit('updateClearClientsFilter');
		},
		onClientsPreloader({ commit }, value) {
			commit('updateClientsPreloader', value);
		},
		async onClients({ commit, dispatch }, isDelete) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/clients');
				if (data && !data.status) {
					data.isDelete = isDelete;
					commit('updateClientsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.CLIENTS, defaultHeader: clientsListHeader });
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onClientsEdit({ commit }, id) {
			commit("updateClientsPreloader", true);
			try {
				const { data } = await httpClient.get(`/clients/${ id }/edit`);
				if (data && !data.status) {
					commit('updateClients', data);
				}
				commit("updateClientsPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onClientsCreate({ commit }, id) {
			commit("updateClientsPreloader", true);
			const url = id ? `/clients/create?customer_id=${ id }` : "/clients/create";
			try {
				const { data } = await httpClient.get(url);
				if (data && !data.status) {
					if (id) {
						return data;
					}
					commit('updateClients', data);
				}
				commit("updateClientsPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onClientsSave({ commit, dispatch }, { values, id, typeDefault }) {
			const typeOfRequest = id ? 'put' : 'post';
			const url = id ? `/clients/${ id }` : '/clients';
			try {
				const { data } = await httpClient[typeOfRequest](url, values);
				if (data) {
					const { status, error, list } = data;
					if (!error) {
						commit('updateAddClientsList', { list, id });
						await dispatch('onClientsFilter', { type: typeDefault });
					}
					return { status, error };
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onClientsFilter({ commit, dispatch }, { isSearch, ...obj }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/clients/list', obj);
				if (isSearch) {
					dispatch("actionPreloader", false);
					return data;
				}

				if (data && !data.status) {
					commit('updateClientsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.CLIENTS, defaultHeader: clientsListHeader });
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onRemoveClients({ dispatch, commit }, id) {
			dispatch('actionPreloader', true);
			try {
				const { data } = await httpClient.delete(`/clients/${ id }`);
				if (data && data.status) {
					commit('updateListAfterRemoveItem', id);
					dispatch('onClients', true);
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async onClientsDelete({ state }) {
			if (state.deleteClientsList.length) await httpClient.post(`/clients/destroyDescription`, { ids: state.deleteClientsList });
		},
		async onInvoiceDelete({ state }) {
			if (state.deleteInvoiceList.length) await httpClient.post(`/clients/destroyInvoice`, { ids: state.deleteInvoiceList });
		},
		getClientsDelete({ commit }, { id, isDelete }) {
			commit('updateClientsDelete', { id, isDelete });
		},
		getInvoiceDelete({ commit }, { id, isDelete }) {
			commit('updateInvoiceList', { id, isDelete });
		}
	},
	getters: {
		clientsList: s => s.clientsList,
		clientsFilter: s => s.clientsFilter,
		clients: s => s.clients,
		clientsPreloader: s => s.clientsPreloader
	}
};
